import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import './PolicyModal.css';

export const PolicyModal = ({ isOpen, onClose }) => {
  const { lang } = useLanguage();
  const [activeTab, setActiveTab] = useState('shipping');

  if (!isOpen) return null;

  const content = {
    en: {
      title: 'Shipping & Returns',
      shipping: 'Shipping',
      returns: 'Returns',
      shipping_content: [
        {
          heading: 'Free shipping within Mexico',
          text: 'All original artworks ship free within Mexico, fully insured. Delivery in 3-7 business days.'
        },
        {
          heading: 'International shipping',
          text: 'Available worldwide. Rates calculated at checkout based on destination, size, and weight. Typical delivery: 7-15 business days. Each shipment is fully insured and tracked.'
        },
        {
          heading: 'Packaging',
          text: 'Every piece is professionally packed in custom crates or rigid art boxes with corner protectors, acid-free paper, and shock-absorbing materials.'
        },
        {
          heading: 'Customs & duties',
          text: 'International buyers are responsible for any import taxes or duties applicable in their country. We provide all required documentation.'
        }
      ],
      returns_content: [
        {
          heading: 'All sales are final',
          text: 'Due to the unique, original nature of each artwork, all sales are final. We do not accept returns or exchanges.'
        },
        {
          heading: 'Damaged in transit',
          text: 'If an artwork arrives damaged, please email carlotatorresll@gmail.com within 48 hours of delivery with photos. All shipments are fully insured and any transit damage will be resolved through the insurance claim.'
        },
        {
          heading: 'Before purchasing',
          text: 'We encourage you to review all artwork images carefully and reach out with any questions before completing your purchase. We are happy to provide additional photos, details, or video on request.'
        }
      ]
    },
    es: {
      title: 'Envíos y Devoluciones',
      shipping: 'Envíos',
      returns: 'Devoluciones',
      shipping_content: [
        {
          heading: 'Envío gratis dentro de México',
          text: 'Todas las obras originales se envían gratis dentro de México, con seguro completo. Entrega en 3-7 días hábiles.'
        },
        {
          heading: 'Envío internacional',
          text: 'Disponible a todo el mundo. Las tarifas se calculan al finalizar la compra según destino, tamaño y peso. Entrega típica: 7-15 días hábiles. Cada envío está completamente asegurado y rastreado.'
        },
        {
          heading: 'Empaque',
          text: 'Cada pieza se empaca profesionalmente en cajas rígidas o crates a medida con protectores de esquina, papel libre de ácido y materiales absorbentes de impacto.'
        },
        {
          heading: 'Aduanas e impuestos',
          text: 'Los compradores internacionales son responsables de cualquier impuesto o arancel aplicable en su país. Proporcionamos toda la documentación requerida.'
        }
      ],
      returns_content: [
        {
          heading: 'Todas las ventas son finales',
          text: 'Debido a la naturaleza única y original de cada obra, todas las ventas son finales. No aceptamos devoluciones ni cambios.'
        },
        {
          heading: 'Daños durante el envío',
          text: 'Si una obra llega dañada, por favor escríbenos a carlotatorresll@gmail.com dentro de 48 horas tras la entrega con fotografías. Todos los envíos están completamente asegurados y cualquier daño en tránsito se resolverá a través de la reclamación del seguro.'
        },
        {
          heading: 'Antes de comprar',
          text: 'Te invitamos a revisar todas las imágenes de la obra cuidadosamente y a contactarnos con cualquier duda antes de completar tu compra. Con gusto compartimos fotos adicionales, detalles o video bajo petición.'
        }
      ]
    }
  };

  const c = content[lang] || content.en;
  const items = activeTab === 'shipping' ? c.shipping_content : c.returns_content;

  return (
    <div className="policy-overlay" onClick={onClose}>
      <div className="policy-modal" onClick={(e) => e.stopPropagation()}>
        <button className="policy-close" onClick={onClose} data-testid="policy-close">
          <X size={20} />
        </button>

        <h2>{c.title}</h2>

        <div className="policy-tabs">
          <button 
            className={`policy-tab ${activeTab === 'shipping' ? 'active' : ''}`}
            onClick={() => setActiveTab('shipping')}
          >
            {c.shipping}
          </button>
          <button 
            className={`policy-tab ${activeTab === 'returns' ? 'active' : ''}`}
            onClick={() => setActiveTab('returns')}
          >
            {c.returns}
          </button>
        </div>

        <div className="policy-content">
          {items.map((item, idx) => (
            <div key={idx} className="policy-item">
              <h3>{item.heading}</h3>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PolicyModal;
